import React from 'react';
import getConfig from 'next/config';
import { Card, CardBody, Col } from 'reactstrap';
import Image from '../image';
import PriceTag from  '../../elements/utils/priceTag';
 
const config = getConfig().publicRuntimeConfig;

const fullySupportedBoxStyle = {
	margin: 0, padding: '5px', display: 'inline-block', border: '1px solid #ff5050', borderRadius: '5px',
};

const BeneficiaryProgramCard = (props) => {
	const { 
		title,
		ngo,
		price,
		image,
		alt,
		programLink,
		headline,
		displayName,
		isInventoryAvailable,
		type} = props.program;
	const { lazyLoadImage, newTab, position, theme } = props;
	const imageType = props.imageType || 'thumbnail';
	return (
		<Col className={props.className}> 
		<Card>
			<a
					rel="noopener noreferrer"
					className="no-hover-a"
					style={{ cursor: 'pointer' }}
					href={`/beneficiary/${programLink}`}
					target={newTab ? '_blank' : '_self'}
					onClick={() => {
						const eventInfo = {
							position: position + 1,
							productName: title,
							productId: null,
							ngo,
							url: window.location.toString(),
						};
						if (window.eventDispatcher) {
							window.eventDispatcher.dispatchEventSync('beneficiaryProgramClick', eventInfo, {amplitude: true});
						}

						return true;
					}}
				>
			<Image width="100%" style={{ opacity: 1 }} src={image} alt={alt} type={imageType} lazyLoad={lazyLoadImage} />
			<CardBody>
				<h5 className="card-title text-clamp-3" style={{ lineHeight: '1.375rem' }}>
					{/* <Link prefetch href={programLink}>} */}
					<span className="darker-grey">
						{displayName || headline || title}
					</span>
				</h5>
				<div className="d-inline-flex">
					<img className="beneficiary-panel-icon" style={{ width: '20px', height: '20px'}} src={`${config.cdnUrl}/static/icons/support-beneficiary-icon.png`} alt="support beneficiary icon" />
					<p className="text-muted ml-1">{ngo}</p>
				</div>
			
			{!isInventoryAvailable ?
				<div style={{ position: 'relative' }}>
					<div className="card-price">
						<h6 className="price" style={fullySupportedBoxStyle}> Fully Supported </h6>
					</div>
				</div> :
				<div className="card-price">
					<h6 className="price">
						<PriceTag price={price} session={props.session} theme={theme}/> <span className="sh"> per month </span>
					</h6>
				</div>}
			</CardBody>
			</a>
		</Card>
		</Col>
	)
}

BeneficiaryProgramCard.defaultProps = {
	size: { lg: '4', sm: '12', xs: '12' },
	className: 'd-flex program-card-11 stack-3',
};

export default BeneficiaryProgramCard;
